import { Star, Quote } from "lucide-react";

export default function Reviews({ data, dark = false }) {
  const items = data?.items || [];
  if (!items.length) return null;
  return (
    <section id="recensioni" className={dark ? "bg-[#0B2A45] text-white" : "bg-white/60 border-y border-stone-200"} data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className={`eyebrow mb-3 ${dark ? "text-[#FDE047]" : "text-[#C2593F]"}`}>{data.eyebrow}</div>
        <h2 className={`font-serif font-semibold text-3xl lg:text-4xl max-w-2xl ${dark ? "text-white" : "text-[#0B2A45]"}`}>{data.title}</h2>
        <div className="mt-10 grid md:grid-cols-3 gap-6">
          {items.map((r, i) => (
            <figure key={`${r.name}-${i}`} className={`rounded-2xl p-6 flex flex-col ${dark ? "bg-white/5 border border-white/10" : "bg-white border border-stone-200"}`} data-testid={`review-${i}`}>
              <Quote className={`w-6 h-6 mb-3 ${dark ? "text-[#FDE047]" : "text-[#C2593F]"}`} />
              <div className="flex gap-0.5 mb-3" aria-label={`${r.rating} stelle`}>
                {["s1", "s2", "s3", "s4", "s5"].map((k, s) => <Star key={k} className={`w-4 h-4 ${s < (r.rating || 5) ? "fill-[#EAB308] text-[#EAB308]" : "text-stone-300"}`} />)}
              </div>
              <blockquote className={`text-sm leading-relaxed flex-1 ${dark ? "text-stone-200" : "text-stone-700"}`}>"{r.text}"</blockquote>
              <figcaption className="mt-5 pt-4 border-t border-current/10">
                <div className={`font-semibold ${dark ? "text-white" : "text-[#0B2A45]"}`}>{r.name}</div>
                <div className={`text-xs ${dark ? "text-stone-400" : "text-stone-500"}`}>{r.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
